import { ANIMATIONS } from './animations';

export class NotificationOptionsModel {
    message: string;
    title: string;
    type: string | NotificationOptionType;
    icon?: NotificationIcon;
    autoClose?: boolean;
    displayTime?: number; // miliseconds
    animation?: ANIMATIONS;
    fixed?: boolean;
    size?: 'md' | 'lg';
}

export class NotificationIcon {
    custom?: boolean;
    border?: boolean;
    size?: string;
    items: NotificationIconItem[];
}

export class NotificationIconItem {
    icon: string;
    style?: 'fas' | 'far' | 'fal' | 'fad' | 'fab';
    size?: string;
    class?: string;
}

export enum NotificationOptionType {
    SUCCESS = 'success',
    DANGER = 'danger',
    WARNING = 'warning',
    INFO = 'info'
}

export enum FORMAT_TYPE {
	PLAIN = 'plain',
	PRETTY = 'pretty',
}

export const NotificationDefaultIcon = {
	success: {
		border: true,
		size: 'fa-2x',
		items: [
			{
				icon: 'fa-circle fa-stack-2x',
				style: 'fas',
				class: 'text-cv-success'
			},
			{
				icon: 'fa-check fa-stack-1x',
				style: 'fas',
				class: 'fa-inverse'
			}
		]
	},

	warning: {
		border: true,
		size: 'fa-2x',
		items: [
			{
				icon: 'fa-circle fa-stack-2x',
				style: 'fas',
				class: 'fa-inverse'
			},
			{
				icon: 'fa-exclamation-circle fa-stack-1x',
				style: 'fas',
				class: 'text-warning'
			}
		]
	},

	danger: {
		border: true,
		size: 'fa-2x',
		items: [
			{
				icon: 'fa-circle fa-stack-2x',
				style: 'fas',
				class: 'fa-inverse'
			},
			{
				icon: 'fa-exclamation-triangle fa-stack-1x',
				style: 'fas',
				class: 'text-danger'
			}
		]
	},

	info: {
		border: true,
		size: 'fa-2x',
		items: [
			{
				icon: 'fa-circle fa-stack-2x',
				style: 'fas',
				class: 'fa-inverse'
			},
			{
				icon: 'fa-info-circle fa-stack-1x',
				style: 'fas',
				class: 'text-cv-info'
			}
		]
	}
}
